import script from "./ProfileSharingEditor.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileSharingEditor.vue?vue&type=script&lang=ts&setup=true"

import "./ProfileSharingEditor.vue?vue&type=style&index=0&id=2993d8c0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2993d8c0"]])

export default __exports__